import { rootRoute } from './root-route';
import { indexRoute } from '@/routes/index.routes';
import { assessmentsRoute } from '@/routes/assessments.routes';

export const routeTree = rootRoute.addChildren([indexRoute, assessmentsRoute]);
